import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { RejectedTaskRow } from "./types";

export function RejectedTasksPanel() {
  const { data: rows = [], isLoading } = useQuery<RejectedTaskRow[]>({
    queryKey: ["/api/admin/task-rejections"],
  });
  return (
    <Card data-testid="panel-rejected-tasks">
      <CardHeader>
        <CardTitle data-tour="admin-rejected-tasks-heading">Rejected Tasks</CardTitle>
        <p className="text-sm text-muted-foreground">
          Every time a host rejects a vendor-completed task, an entry is logged here. The vendor receives an SMS and a red in-app alert with the reason.
        </p>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <p className="text-sm text-muted-foreground">Loading…</p>
        ) : rows.length === 0 ? (
          <p className="text-sm text-muted-foreground" data-testid="text-no-rejected-tasks">No task rejections recorded.</p>
        ) : (
          <Table data-tour="admin-rejected-tasks-table">
            <TableHeader>
              <TableRow>
                <TableHead>When</TableHead>
                <TableHead>Task</TableHead>
                <TableHead>Host</TableHead>
                <TableHead>Vendor</TableHead>
                <TableHead>Reason / Comments</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} data-testid={`row-rejected-task-${r.id}`}>
                  <TableCell className="whitespace-nowrap text-xs text-muted-foreground">
                    {new Date(r.createdAt).toLocaleString()}
                  </TableCell>
                  <TableCell className="font-medium">
                    {r.taskTitle} <span className="text-xs text-muted-foreground">#{r.taskId}</span>
                  </TableCell>
                  <TableCell data-testid={`text-rejected-host-${r.id}`}>
                    {r.hostName || r.hostEmail || `User #${r.hostUserId}`}
                    {r.hostEmail && r.hostName && (
                      <div className="text-xs text-muted-foreground">{r.hostEmail}</div>
                    )}
                  </TableCell>
                  <TableCell data-testid={`text-rejected-vendor-${r.id}`}>
                    {r.vendorName || (r.vendorId ? `Vendor #${r.vendorId}` : "—")}
                  </TableCell>
                  <TableCell className="max-w-md whitespace-pre-wrap text-sm" data-testid={`text-rejected-reason-${r.id}`}>
                    {r.reason}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
